// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"4f5edd38","491":"97da25bf","565":"3014391a","675":"a98bccd5","787":"0f09fb70","863":"88174202"}[chunkId] + ".chunk.js";
};